module.exports = __webpack_public_path__ + "img/secovipr.85ab5250.webp";